export class ChangeTypeDto {
    id?: number;
    label?: string;
    order?: number;
    requiresBranchPlant?: boolean;
    status?: boolean;
}